import { Directive } from '@angular/core'

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input',
  standalone: true,
})
export class NativeInputDirective {}
